import { api } from '../api'

import type {
  ProductionLogEndTimePayload,
  ProductionLogMultiCompletePayload,
  ProductionLogMultiupdateByIdsPayload,
  ProductionLogMultiupdatePayload,
  ProductionLogStartPayload,
  ProductionLogUpdatePayload
} from './production-logs-types'

export const productionLogService = {
  update: async (id: number, payload: ProductionLogUpdatePayload) => {
    const { data } = await api.patch(`/production-logs/${id}/`, payload)

    return data
  },
  addEndTime: async (id: number, payload: ProductionLogEndTimePayload) => {
    const { data } = await api.post(`/production-logs/${id}/end-time/`, payload)

    return data
  },
  multiComplete: async (payload: ProductionLogMultiCompletePayload) => {
    const { data } = await api.post('/production-logs/multi-complete/', payload)

    return data
  },
  addStartTime: async (payload: ProductionLogStartPayload) => {
    const { data } = await api.post('/production-logs/start-time/', payload)

    return data
  },
  multiupdate: async (payload: ProductionLogMultiupdatePayload) => {
    const { data } = await api.post('/production-logs/multi-update/', payload)

    return data
  },
  multiupdateByIds: async (payload: ProductionLogMultiupdateByIdsPayload) => {
    const { data } = await api.post('/production-logs/multi-update-by-ids/', payload)

    return data
  }
}
